export default __webpack_public_path__ + "static/media/nguyetpha.2224e005.png";